import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import CmsTransformer from '~/components/cms/CmsTransformer';
import { useSlugTranslations } from '~/context/SlugTranslationsContext';
import Layout from '~/layouts/Default';
import { CmsItem } from '~/types/Cms';

interface CmsPageProps {
  pageData: {
    contentData: CmsItem[];
    title: string;
    slugTranslations?: Record<string, string>;
  } | null;
  /** Page was fetched with an admin preview token — it may be an unpublished draft. */
  isPreview?: boolean;
}

const CmsPage = ({ pageData, isPreview = false }: CmsPageProps) => {
  const { setSlugTranslations } = useSlugTranslations();
  const { t } = useTranslation();

  // Set slug translations for language switcher
  useEffect(() => {
    if (pageData?.slugTranslations) {
      setSlugTranslations(pageData.slugTranslations);
    }
    return () => setSlugTranslations(null);
  }, [pageData?.slugTranslations, setSlugTranslations]);

  if (!pageData?.contentData?.length) return null;

  return (
    <Layout>
      {isPreview && (
        <div className="cms-preview-badge" role="status">
          {t('pages.cms.preview_badge')}
        </div>
      )}
      <Container className="cms-content">
        <h1 className="mt-5 mb-3 text-uppercase cms-content__title">{pageData?.title}</h1>
        {pageData.contentData.map((item, idx) => {
          return <CmsTransformer key={idx} item={item} />;
        })}
      </Container>
    </Layout>
  );
};

export default CmsPage;
